let idCounter = 0
const uniqueId = () => ++idCounter
export default uniqueId
